const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/console/_auth/_layout/patient/$accountId_.monitor.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { type MonitorAIAnalysis, type MonitorDietAnalysis, type MonitorExerciseAnalysis, type MonitorMatrixRow, type MonitorRange, type MonitorRecordDetail, type MonitorRecordItem, type MonitorTrendSeries } from '@/api/patient-monitor';
// 筛选放 URL 而不是组件状态：跳去饮食修正页再退回来时要原样还原，
// 顺带让刷新不丢筛选、视图可以直接发给同事
type MonitorSearch = {
  rangeDays: number;
  category: string;
  onlyAbnormal: boolean;
  pageNo: number;
  pageSize: number;
};

// 进入本页的默认筛选；外部导航过来时带上它，TanStack 要求 search 是完整对象
export const MONITOR_SEARCH_DEFAULTS: MonitorSearch = {
  rangeDays: 30,
  category: '',
  onlyAbnormal: false,
  pageNo: 1,
  pageSize: 20
};
export const Route = createFileRoute('/console/_auth/_layout/patient/$accountId_/monitor')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (search: Record<string, unknown>): MonitorSearch => ({
    rangeDays: Number(search.rangeDays) || MONITOR_SEARCH_DEFAULTS.rangeDays,
    category: typeof search.category === 'string' ? search.category : '',
    onlyAbnormal: search.onlyAbnormal === true || search.onlyAbnormal === 'true',
    pageNo: Number(search.pageNo) || MONITOR_SEARCH_DEFAULTS.pageNo,
    pageSize: Number(search.pageSize) || MONITOR_SEARCH_DEFAULTS.pageSize
  })
});

// region 依从性总览

// endregion

// region 打卡矩阵

// 格子配色：完成/过期/待打卡三态，非计划日留白

// endregion

// region 打卡记录列表

// 复用方案模块图标，保持后台各处同一类内容图形一致

// endregion

// region 记录详情抽屉

// 三类打卡的记录结构差异大，按 category 分别渲染，公共壳只管时间、备注和来源

// aiAnalysis 的结构由 category 决定，按判别字段收窄；读不出就当没有识别结果

// 运动打卡 data 恒为空对象，只有「完成了」这一个事实，不编造数值

// endregion

// region 指标趋势

// 系列配色按类别固定，不随数据顺序漂移

// 固定展示的指标类型与顺序；label 只作加载期占位，真实文案以接口返回为准
// 固定而非按数据动态发现：空卡本身就是信息（说明患者这项没在测），布局也不会随数据跳动

// levelRank 档位严重度，取一条记录的最差档位时用

// 明细列表按记录维度展示，和趋势图看的是同一份数据，只是换成能读出准确数值的形态

// TrendDot 用点形状承载两个信息：填充=打卡来源，红色=异常档位

// endregion

// region 展示格式
// niceDomain 把上下界对齐到 1/2/5 系列的整齐步长，避免出现 38.7 这种刻度
// endregion
// endregion
// SwipeRow 仅对可删除行启用左滑露出删除按钮,其他行直接透传内容
// endregion
// AI 巡查风险等级 → 徽章文案与色调
// 随访状态 → 徽章文案与色调, 已取消的不会出现在首页
// 复查提醒与随访卡片的统计范围说明
// 用户来源分类与条形配色, 顺序即展示顺序; 平台是「无院内记录」的兜底类, 用中性灰
// 各指标的口径说明, 集中放一处便于核对
// endregion
// 管理视角: 超管额外看到管理归属、覆盖、活跃趋势与功能使用; 健管师 / 运营员只看基础概览
// 超管的核心指标: 用真实的活跃与新增替代原先写死的两项 100%
// region 复查提醒与患者随访
// 管理视角和医生工作台共用, 统计范围由服务端按角色决定, 卡片描述里写明
// 上面一排底色统计格, 下面是近 7 天的明细列表
// endregion
// 用户来源分布: 横向条形, 全为 0(含数据未就绪)时按无数据占位
// 指标行:仿模板 KPI 行;纯数字走 KPI.Value,带 % 等符号的直接文本渲染
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}